import api from "api";
import LayoutItem from "components/LayoutItem";
import React, { useState, useEffect } from "react";
import { Modal } from "reactstrap";
import { Button } from "shared";
import { normalizeExtraData } from "utils/CustomFieldHelper";
import t, { getCurrentLanguage } from "utils/Lang";

type ModalCreateFieldProps = {
  isOpen: boolean;
  toggle: (event?: React.KeyboardEvent<any>) => void;
  id?: number;
  user: any;
  onClosed: () => void;
  group: any;
  selectedFieldId?: any;
  onCreated: (data: any, groupId: number) => void;
  onUpdated: (data: any, groupId: number) => void;
  onDeleted: (fieldId: number, groupId: number) => void;
};

const ModalCreateField = ({
  isOpen,
  toggle,
  user,
  onClosed,
  group,
  selectedFieldId,
  onCreated,
  onUpdated,
  onDeleted,
}: ModalCreateFieldProps) => {
  const [fieldData, setFieldData] = useState<any>({
    content_type: "site",
    is_active: true,
    scope: "custom",
    is_view_only: false,
    is_show: true,
  });
  useEffect(() => {
    if (selectedFieldId) fetchFieldDetail();
  }, [selectedFieldId]);
  const fetchFieldDetail = async () => {
    const res = await api.getFieldDetail(selectedFieldId);
    if (res.status === "ok") {
      setFieldData((data: any) => ({
        ...data,
        name: res?.studio_field?.languages?.vi,
        name_en: res?.studio_field?.languages?.en,
        field_data_type: res?.studio_field?.field_data_type,
        extra_data: Object.values(res?.studio_field?.extra_data || {}).join(
          ", "
        ),
        is_show: res?.studio_field?.is_show,
      }));
    }
  };
  const uiLayoutDefinition = [
    {
      attributeName: "brand",
      type: "text",
      data: user?.user_brand?.brand_name,
      label: "Brand",
      disabled: true,
    },
    {
      attributeName: "studio_group",
      type: "text",
      data: group.name,
      label: "Studio Group",
      disabled: true,
    },
    {
      attributeName: "name",
      type: "text",
      label: "Field name (*)",
    },
    {
      attributeName: "name_en",
      type: "text",
      label: "Field name (en)",
    },
    {
      attributeName: "field_data_type",
      type: "dropdown",
      label: "Field data type (*)",
      options: [
        { value: "text", label: "text" },
        { value: "textarea", label: "textarea" },
        { value: "number", label: "number" },
        { value: "decimal", label: "decimal" },
        { value: "dropdown", label: "dropdown" },
        { value: "date", label: "date" },
      ],
    },
    {
      attributeName: "is_show",
      type: "check",
      label: "Show field",
    },
    {
      attributeName: "extra_data",
      type: "text",
      label: "Extra Data",
      placeholder: "value 1, value 2, value 3...",
    },
  ];
  const onSave = async () => {
    if (!fieldData.name) {
      alert("Field name can not be empty");
      return;
    }
    if (!fieldData.field_data_type) {
      alert("Field data type can not be empty");
      return;
    }
    if (fieldData.field_data_type === "dropdown" && !fieldData.extra_data) {
      alert("Field extra data can not be empty");
      return;
    }
    const data = {
      name: fieldData.name,
      studio_group_id: parseInt(group.id),
      field_data_type: fieldData.field_data_type,
      extra_data: normalizeExtraData(fieldData.extra_data),
      languages: {
        vi: fieldData.name,
        en: fieldData.name_en,
      },
      is_show: fieldData.is_show,
    };
    if (selectedFieldId) {
      const res = await api.updateField(data, selectedFieldId);
      onUpdated(
        {
          id: selectedFieldId,
          name: data.languages[getCurrentLanguage() || "vi"],
          extra_data: fieldData.extra_data,
          field_data_type: fieldData.field_data_type,
          is_show: fieldData.is_show,
        },
        group.id
      );
    } else {
      const res = await api.createField(data);
      onCreated(res.studio_field, group.id);
    }
    toggle();
  };

  const updateAtt = (att: string, val: any) => {
    let value = val;
    if (typeof val == "object") {
      if (val?.length > 0) {
        // good
      } else {
        value = val.value;
      }
    }
    setFieldData((dt: any) => {
      if (dt) {
        return {
          ...dt,
          [att]: value,
        };
      }
      return { [att]: value };
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ padding: 30 }}
      onClosed={onClosed}
    >
      <div className="modal-custom-field__header">
        <span className="modal-custom-field__header__title">
          {selectedFieldId
            ? t().modal_create_field__edit_field
            : t().modal_create_field__create_field}
        </span>
        <i className="material-icons btn-close" onClick={() => toggle()}>
          close
        </i>
      </div>
      <div className="modal-custom-field__body">
        {uiLayoutDefinition.map((item) => (
          <LayoutItem
            key={item.attributeName}
            item={item}
            statusData={fieldData}
            callback={updateAtt}
          />
        ))}
      </div>
      <div className="modal-custom-field__footer">
        {selectedFieldId && (
          <>
            <Button
              label={t().action__delete}
              onClick={() => {
                onDeleted(selectedFieldId, group.id);
                toggle();
              }}
              size="small"
              type="danger"
            />
            <div style={{ width: 10 }} />
          </>
        )}
        <Button
          label={t().action__done}
          onClick={onSave}
          size="small"
          type="primary"
        />
      </div>
    </Modal>
  );
};

export default ModalCreateField;
